export enum MessageType {
	TEXT = 'TEXT',
}
